import { Action } from 'redux';
import { PROJECT_LIST_SET_COLUMNS } from 'src/modules/project-list/actions/ProjectListActions';
import { ProjectListState } from 'src/modules/project-list/types/ProjectListState';

export function projectListColumnsReducer(state: ProjectListState, action: Action): ProjectListState {
  if (PROJECT_LIST_SET_COLUMNS.is(action)) {
    return {
      ...state,
      columns: action.data,
    };
  }

  return state;
}
